import { API, getRequestBlob } from '@/api/api';
import type { ChatAttachment, ChatMessageData } from '@/components';

const isImageAttachment = (attachment: ChatAttachment) =>
  attachment.isImage ||
  (attachment.type ?? '') === 'image' ||
  (attachment.type ?? '').startsWith('image/');

const toFile = async (attachment: ChatAttachment): Promise<File | null> => {
  const link = attachment.link ?? attachment.url;
  if (!link) return null;

  const name = attachment.name || 'photo';

  if (link.includes('/api/v1/')) {
    const blob = await getRequestBlob(API.DOCUMENTS, link);
    return new File([blob], name, { type: blob.type });
  }

  const response = await fetch(link);
  const blob = await response.blob();
  return new File([blob], name, { type: blob.type });
};

export const getChatImageFiles = async (message: ChatMessageData): Promise<File[]> => {
  const images = (message.attachments ?? []).filter(isImageAttachment);
  if (images.length === 0) return [];

  const files = await Promise.all(images.map(toFile));
  return files.filter((file): file is File => !!file);
};
